import React, { Component } from 'react';
import { Card, Row, Table } from 'antd';
import { connect } from 'react-redux';
import '../../expenses.less';
import DescriptionList from '@comm/DescriptionList';
import { queryFilePreview } from '@api/pub/attachment';
import { Link } from 'react-router';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {
    this.setState({
      dataItem: this.props.data,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  chaptersColumns = () => {
    return [
      {
        title: '用章公司',
        dataIndex: 'company',
        key: 'company',
        width: '40%',
      },
      {
        title: '用章类型',
        dataIndex: 'type',
        key: 'type',
        width: '30%',
        render: text => {
          switch (text) {
            case 0:
              return '公章';
            case 1:
              return '合同章';
            case 2:
              return '法人章';
            default:
              break;
          }
        },
      },
      {
        title: '是否外借',
        dataIndex: 'seal',
        key: 'seal',
        width: '30%',
        render: text => {
          if (text === 0) {
            return '不外借';
          }
          return '外借';
        },
      },
    ];
  };

  effectColumns = () => {
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '附件',
        dataIndex: 'files',
        key: 'files',
        render: text => {
          return (
            <div>
              {text
                ? text.map(item => {
                    return (
                      <div key={item.url}>
                        <a onClick={() => queryFilePreview(item)}>{item.name}</a>
                      </div>
                    );
                  })
                : null}
            </div>
          );
        },
      },
      {
        title: '扫描件',
        dataIndex: 'scans',
        key: 'scans',
        render: text => {
          return (
            <div>
              {text
                ? text.map(item => {
                    return (
                      <div key={item.url}>
                        <a onClick={() => queryFilePreview(item)}>{item.name}</a>
                      </div>
                    );
                  })
                : null}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { dataItem } = this.state;
    return (
      <div className="form-open">
        <Card title="用章详情">
          <DescriptionList size="large" col={3}>
            <Description term="申请人员">{dataItem.createUserName}</Description>
            <Description term="续证资料名称">
              <Link to={`/administrative/material/info/${dataItem.documentUuid}`}>
                {dataItem.documentName}
              </Link>
            </Description>
            <Description term="新资料名称">
              <Link to={`/administrative/material/info/${dataItem.newDocumentUuid}`}>
                {dataItem.newDocumentName}
              </Link>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="说明">{dataItem.reason}</Description>
          </DescriptionList>
          <Row style={{ height: '30px', fontWeight: 'bold', paddingTop: '10px' }}>用章类别</Row>
          <Table
            columns={this.chaptersColumns()}
            dataSource={dataItem.chapters}
            pagination={false}
          />
          <Row style={{ height: '30px', fontWeight: 'bold', paddingTop: '10px' }}>用章附件</Row>
          <Table
            columns={this.effectColumns()}
            dataSource={dataItem.renewalFiles}
            pagination={false}
          />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/administrative/material/renewal/FormOpen.js